import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';

export const getReservationCart = (reservationCartId) =>
  axios.get(
    `${getV2RootUrl()}/reservation-cart/${reservationCartId}`,
    publicAxiosHeaderV2()
  );

export const getReservationCartVirtualCart = (reservationCartId) =>
  axios.get(
    `${getV2RootUrl()}/reservation-cart/${reservationCartId}/virtual-cart`,
    publicAxiosHeaderV2()
  );

export const createReservationCart = (reservationCart) =>
  axios.post(
    `${getV2RootUrl()}/reservation-cart`,
    reservationCart,
    publicAxiosHeaderV2()
  );
export const addCouponCode = (reservationCartId, data) =>
  axios.post(
    `${getV2RootUrl()}/reservation-cart/${reservationCartId}/coupon`,
    data,
    publicAxiosHeaderV2()
  );

export const updateReservationCart = (reservationCartId, reservationCart) =>
  axios.put(
    `${getV2RootUrl()}/reservation-cart/${reservationCartId}`,
    reservationCart,
    publicAxiosHeaderV2()
  );

export const processReservationCart = (reservationCartId) =>
  axios.put(
    `${getV2RootUrl()}/reservation-cart/${reservationCartId}/process`,
    {},
    publicAxiosHeaderV2()
  );

export const processPayStackReservationCart = (reservationCartId, tenderId) =>
  axios.put(
    `${getV2RootUrl()}/reservation-cart/${reservationCartId}/process-from-pay-stack`,
    { tenderId },
    publicAxiosHeaderV2()
  );
